import { motion } from "framer-motion";
import { Building2 } from "lucide-react";
import { useContent } from "@/content";

export const Industries = () => {
  const { INDUSTRIES } = useContent();
  return (
  <section className="relative bg-white border-t border-slate-200 py-14 md:py-16" data-testid="industries-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-8 grid lg:grid-cols-[auto_1fr] gap-8 lg:gap-14 items-center">
      <motion.div
        initial={{ opacity: 0, x: -20 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="flex items-center gap-4 lg:max-w-xs"
      >
        <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-amber-400/10 border border-amber-400/30">
          <Building2 className="h-5 w-5 text-amber-500" />
        </span>
        <div>
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-slate-400">Industries we serve</p>
          <p className="text-sm text-slate-600 mt-1">Proven across sectors — and quick to learn yours.</p>
        </div>
      </motion.div>
      <ul className="flex flex-wrap gap-2.5" data-testid="industries-list">
        {INDUSTRIES.map((name, i) => (
          <motion.li
            key={name}
            initial={{ opacity: 0, y: 12, scale: 0.9 }}
            whileInView={{ opacity: 1, y: 0, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.45, delay: i * 0.05, ease: [0.22, 1, 0.36, 1] }}
            whileHover={{ y: -3 }}
            className="rounded-full border border-slate-200 bg-slate-50 px-4 py-2 text-sm text-slate-700 hover:border-amber-400 hover:bg-amber-50 hover:text-amber-700 cursor-default transition-colors duration-300"
          >
            {name}
          </motion.li>
        ))}
      </ul>
    </div>
  </section>
);
};
